module.exports = __webpack_public_path__ + "static/media/Trust-Spectrum-Logo.0d5bf058.png";